import { request } from '@/api/httpClient'
import { ProductType } from '@/enums'

export async function authLoginStaff(username, password) {
  const response = await request({
    method: 'auth/loginstaff',
    payload: {
      Email: username,
      Password: password
    }
  })

  if (response?.loginStatus === 0) {
    return {
      id: response.contactId,
      companyName: response.companyName,
      firstName: response.firstName,
      lastName: response.lastName,
      image: response.image,
      username,
      email: username,
      staffLogin: true,
      admin: response.admin,
      tokenExpiry: response.expiresAt,
      refreshAfter: response.refreshAfter,
      loginStatus: response?.loginStatus
    }
  }

  return {
    message: response?.message,
    loginStatus: response?.loginStatus
  }
}

export async function authLoginCustomer(username, password) {
  const response = await request({
    method: 'auth/logincustomer',
    payload: {
      Email: username,
      Password: password
    }
  })

  if (response?.loginStatus === 0) {
    return {
      companyName: response.companyName,
      firstName: response.firstName,
      lastName: response.lastName,
      image: response.image,
      username,
      email: username,
      admin: response.admin,
      id: response.contactId,
      tokenExpiry: response.expiresAt,
      refreshAfter: response.refreshAfter,
      loginStatus: response?.loginStatus
    }
  }

  return {
    message: response?.message,
    loginStatus: response?.loginStatus
  }
}

export async function authVendorGuest(alias, returnUrl) {
  return request({
    method: 'auth/VendorGuest',
    payload: {
      Alias: alias,
      ReturnUrl: returnUrl
    }
  })
}

export function authGetJWT() {
  return request({
    method: 'auth/GetJWT'
  })
}

export async function authGetMyStoreLinkToken() {
  return request({
    method: 'auth/GetMyStoreLinkToken'
  })
}

export async function authRequestPasswordReset(username) {
  return request({
    method: 'auth/RequestPasswordReset',
    payload: {
      Email: username
    }
  })
}

export async function authGetCookie(endpoint) {
  await request({
    method: { endpoint, method: 'auth/GetCookie' }
  })
}

export async function authResetPassword({ token, password }) {
  return request({
    method: 'auth/ResetPassword',
    payload: {
      Token: token,
      Password: password
    }
  })
}

export async function authCheckPasswordResetToken(token) {
  return request({
    method: 'auth/CheckPasswordResetToken',
    payload: {
      Token: token
    }
  })
}

export async function authIsDesignerAvailable(ecommerceAccountAlias) {
  return request({
    method: 'auth/isDesignerAvailable',
    payload: {
      EcommerceAccountAlias: ecommerceAccountAlias,
      Product: Number(ProductType.BRANDED)
    }
  })
}

export async function authUpdateCompanyWebSettings(key, value) {
  return request({
    method: 'auth/UpdateCompanyWebSettings',
    payload: {
      key,
      value
    }
  })
}

export async function authGetCompanyWebSettings() {
  return request({
    method: 'auth/GetCompanyWebSettings'
  })
}

export async function authGetOrganisationWebSetting(searchKey) {
  return request({
    method: 'auth/GetOrganisationWebSetting',
    payload: {
      SearchKey: searchKey
    }
  })
}

export async function authLoginSuperUser(username, password, email) {
  const response = await request({
    method: 'auth/LoginSuperUser',
    payload: {
      Username: username,
      Password: password,
      ContactEmail: email
    }
  })

  if (response?.loginStatus === 0) {
    return {
      companyName: response.companyName,
      firstName: response.firstName,
      lastName: response.lastName,
      image: response.image,
      username,
      email: username,
      admin: response.admin,
      id: response.contactId,
      superuser: true,
      tokenExpiry: response.expiresAt,
      refreshAfter: response.refreshAfter,
      loginStatus: response?.loginStatus
    }
  }

  return {
    message: response?.message,
    loginStatus: response?.loginStatus
  }
}

export async function authGetAuthorisedProducts() {
  return request({
    method: 'auth/AuthorisedProducts'
  })
}

export async function authLogout() {
  return request({
    method: 'auth/logout'
  })
}
